<app-navbar></app-navbar>
<main>
  <section class="header relative pt-16 items-center flex mt-36">
    <div class="container mx-auto px-4 ">
      <div class="items-center flex flex-wrap justify-center ">
        <h3 class="font-semibold tracking-wide text-2xl lg:text-3xl text-center info-color">Join Banan – Be Part of the Digital Identity Revolution</h3>

      </div>
      <p class=" text-xl lg:text-xl mt-4 info-color text-center  leading-10">Ready to transform how you connect online? Banan is your gateway to secure, reliable digital identity management. </p>
      <p class=" text-xl lg:text-xl mt-4 info-color text-center  leading-10">Here’s what you need to know:</p>

    </div>
  </section>

  

  <section class="relative pb-20">    
    <div class="container mx-auto px-4 pb-16 pt-10">
      <div class="flex flex-wrap">
        <!-- First block with title and text -->
        <div class="w-full md:w-5/12 ml-auto px-8 md:px-4 mb-6">
          <div class="md:pr-12">
            <h3 class="text-2xl font-semibold secondary-color mt-6 text-center">Why Join Banan?</h3>
            <p class="mt-4 text-lg leading-relaxed info-text text-justify">
              Banan, as a Trust Service Provider, offers invaluable benefits to your organization through a 
              secure and efficient platform designed to enhance operations and build trust. It streamlines customer
              onboarding processes, ensures robust data protection, enables seamless and private communication, 
              and supports compliance with critical regulations such as KYC and AML. By providing access to a 
              trusted network of public and private services, Banan empowers organizations to simplify operational 
              complexities, improve efficiency, and foster customer trust through advanced encryption and reliable 
              identity verification in one comprehensive solution.
            </p>
          </div>
        </div>
        
        <!-- Second block with title and text -->
        <div class="w-full md:w-5/12 ml-auto px-8 md:px-4 mb-6">
          <div class="md:pr-12">
            <h3 class="text-2xl font-semibold secondary-color mt-6 text-center">How can you go onboard with Banan?</h3>
            <p class="mt-4 text-lg leading-relaxed info-text text-justify">
              By registering with Banan as trust Service Provider, organizations unlock a competitive advantage, 
              streamline operations, and deliver seamless, secure experience to their customers, 
              all while adhering to the highest standards of security and regulatory compliance.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
  
  


  <section class="relative pb-20">
    <div class="container mx-auto px-4 ">
      <div class="items-center flex flex-wrap justify-center ">
        <h3 class=" tracking-wide text-xl lg:text-xl text-center info-color px-10">
          To get started, simply reach out to the Banan team and submit the required documentation for a smooth onboarding process.  <span (click)="chnage()" class="cursor-pointer  underline underline-offset-8 primary-color" style="text-decoration-thickness: 2px;" >Contact Us</span> </h3>

      </div>

      <div class="isolate bg-white px-6 py-2 sm:py-32 lg:px-8" *ngIf="isVisible">
        <div class="absolute inset-x-0 top-[-10rem] -z-10 transform-gpu overflow-hidden blur-3xl sm:top-[-20rem]" aria-hidden="true">
          <div class="relative left-1/2 -z-10 aspect-[1155/678] w-[36.125rem] max-w-none -translate-x-1/2 rotate-[30deg] bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-30 sm:left-[calc(50%-40rem)] sm:w-[72.1875rem]" style="clip-path: polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)"></div>
        </div>
        <form [formGroup]="form" (ngSubmit)="onSubmit()" class="mx-auto mt-16 max-w-3xl sm:mt-20">
          <div class="grid grid-cols-1 gap-x-8 gap-y-6 sm:grid-cols-2">
            <div>
              <label for="subject" class="block text-sm font-semibold leading-6 text-gray-900">Subject</label>
              <div class="mt-2.5">
                <input type="text" name="subject" formControlName="subject" autocomplete="given-name" class="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6">
                <div *ngIf="form.get('subject').invalid && (form.get('subject').dirty || form.get('subject').touched)" class="mt-2 text-red-600 text-sm">
                  Please enter a subject.
                </div>
              </div>
            </div>
            <div>
              <label for="company" class="block text-sm font-semibold leading-6 text-gray-900">Company</label>
              <div class="mt-2.5">
                <input type="text" name="company" id="company" autocomplete="family-name" class="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6">
              </div>
            </div>
            <div class="sm:col-span-2">
              <label for="name" class="block text-sm font-semibold leading-6 text-gray-900">Name</label>
              <div class="mt-2.5">
                <input type="text" name="name" id="name" autocomplete="given-name" class="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6">
              </div>
            </div>
          
            <!-- <div class="sm:col-span-2">
              <label for="company" class="block text-sm font-semibold leading-6 text-gray-900">Company</label>
              <div class="mt-2.5">
                <input type="text" name="company" id="company" autocomplete="organization" class="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6">
              </div>
            </div> -->
            <div class="sm:col-span-2">
              <label for="email" class="block text-sm font-semibold leading-6 text-gray-900">Email</label>
              <div class="mt-2.5">
                <input type="email" name="email" id="email" formControlName="from" autocomplete="email" class="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6">
                <div *ngIf="form.get('from').invalid && (form.get('from').dirty || form.get('from').touched)" class="mt-2 text-red-600 text-sm">
                  Please enter a valid email address.
                </div>
              </div>
            </div>
         
            <div class="sm:col-span-2">
              <label for="message" class="block text-sm font-semibold leading-6 text-gray-900">Message</label>
              <div class="mt-2.5">
                <textarea name="message" formControlName="body" id="message" rows="4" class="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"></textarea>
                <div *ngIf="form.get('body').invalid && (form.get('body').dirty || form.get('body').touched)" class="mt-2 text-red-600 text-sm">
                  Please enter the Message text.
                </div>
              </div>
            </div>
        
          </div>
          <div class="mt-10">
            <button type="submit"  (click)="onSubmit()"  class="block w-full rounded-md bg-color-primary px-3.5 py-2.5 text-center text-sm font-semibold text-white shadow-sm hover:bg-blueGray-600  focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">Send</button>
          </div>
        </form>
      </div>
    </div>
  </section>
</main>


<app-footer></app-footer>


